import { TextField, useTheme } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useState } from "react";

interface Props {
  onCommentChange: (comment: string) => void;
}

export const CommentCell = ({ onCommentChange }: Props) => {
  const theme = useTheme();
  const { t } = useTenantTranslation();

  const [comment, setComment] = useState("");

  const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newComment = event.target.value;
    setComment(newComment);
    onCommentChange(newComment);
  };

  return (
    <TextField
      sx={{
        minWidth: 250,
        "& .MuiOutlinedInput-root": {
          backgroundColor: theme.palette.background.paper,
          "&:hover": {
            backgroundColor: theme.palette.grey[50],
          },
          "&.Mui-focused": {
            backgroundColor: theme.palette.background.paper,
          },
        },
      }}
      variant="outlined"
      size="small"
      multiline
      rows={1}
      value={comment}
      onChange={handleCommentChange}
      placeholder={t("reasonForChanges")}
      fullWidth
    />
  );
};
